import React, { Component } from 'react';

import AirSlider from '../../../../../../common/components/AirSlider';
import moment from "moment";
import { inject, observer } from 'mobx-react';

import { isFunction } from 'lodash';

import './EndDateYearFilter.css';

@inject('translationsStore', 'subscriptionsStore', 'filterStore')
@observer
export default class EndDateYearFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        endDates: null
      });
    }
  };

  changeWndDates = endDates => {
    if (endDates[0] !== Infinity) {
      this.setState({endDates});
      this.props.filterStore.add('subscriptionFilter_endDate', subscription => moment(subscription.endDate).format('YYYY') >= this.state.endDates[0] && moment(subscription.end_date).format('YYYY') <= this.state.endDates[1]);
    }
  };

  render() {
    const { translationsStore, subscriptionsStore } = this.props;
    const { endDates } = this.state;

    return (
      <div className="registrationYear">
        <AirSlider
          label={translationsStore.translate('subscriptionManager.filter.endDateYear')}
          value={endDates || [subscriptionsStore.registrationYearMin, subscriptionsStore.registrationYearMax]}
          disabled={subscriptionsStore.registrationYearMin === subscriptionsStore.registrationYearMax}
          min={subscriptionsStore.registrationYearMin}
          max={subscriptionsStore.registrationYearMax}
          range
          showLocale={false}
          onChange={this.changeWndDates}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/EndDateYearFilter/EndDateYearFilter.js